import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 2H1v16h9l-2 3v1h8v-1l-2-3h9V2zm-2 12H3V4h18v10z"
}), 'DesktopMacSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DesktopMacSharp.js
// module id = 3106
// module chunks = 2